<template>
  <div>
    <el-upload
      class="upload-demo"
      ref="upload"
      :action="requesUrl ? requesUrl + '/upload/fileupload' : ''"
      :headers="token"
      :on-success="handleAvatarSuccess"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :multiple="true"
      :auto-upload="true"
      list-type="picture"
    >
      <el-button size="mini" type="success">选择文件</el-button>
      <el-button size="mini" type="primary" @click.stop="showUploadDialog">拖拽上传</el-button>
      <el-button v-if="showLiangtian" size="mini" type="primary" @click.stop="openHighBeatMeter">良田高拍仪</el-button>
      <el-button v-if="showOtherGPY" size="mini" type="primary" @click.stop="openHighBeatMeter1">其他高拍仪</el-button>
      <el-button v-if="showScan" size="mini" type="primary" @click.stop="scanUpload">扫描仪</el-button>
      
      <template slot="file" slot-scope="{file}">
        <div class="custom-upload-item active" @click="handleSelect(file)">
          <img class="custom-img" :src="file.url" alt="">
          <div class="custom-actions">
            <i class="el-icon-view" @click.stop="handlePreview(file)"></i>
            <i class="el-icon-delete" @click.stop="deleteFile(file)"></i>
          </div>
          <div class="select-check">
            <i class="el-icon-check"></i>
          </div>
          <div class="img-name" :title="file.name">{{ file.name }}</div>
        </div>
      </template>
    </el-upload>

    <el-dialog :visible.sync="dialogImg" :before-close="handleClose" width="60%" append-to-body :close-on-click-modal="true">
      <img v-if="imageUrl" :src="imageUrl" style="width:100%">
    </el-dialog>

    <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :limit="100" @confirm="onUploadConfirm" />
    
    <el-dialog title="高拍仪拍照" destroy-on-close :visible.sync="dialogGPY" width="900px" style="overflow: hidden;height: 700px;" :before-close="handleClosegpy" append-to-body>
      <div id="myactive">
        <span>图片质量:</span> <el-select id="view1_mode" v-model="altimeterData.quality">
          <el-option label="默认质量" value="0"></el-option>
          <el-option label="高质量" value="1"></el-option>
          <el-option label="较高质量" value="2"></el-option>
          <el-option label="中质量" value="3"></el-option>
          <el-option label="较低质量" value="4"></el-option>
          <el-option label="低质量" value="5"></el-option>
        </el-select>
        <span>色彩模式:</span><el-select size="mini" inline v-model="altimeterData.ColorMode">
          <el-option label="白纸印章" value="3"></el-option>
          <el-option label="彩色" value="0"></el-option>
          <el-option label="黑白" value="2"></el-option>
        </el-select>
        <el-button style="margin-left:10px" @click="rotate(90)" type="primary" size="mini" icon="el-icon-refresh-left" circle></el-button>
        <el-button style="margin-left:10px" @click="rotate(270)" type="primary" size="mini" icon="el-icon-refresh-right" circle></el-button>
        <span style="margin-left:10px">剪切值:</span>
        <el-input-number style="margin-left:10px ;" v-model="altimeterData.deskewval" size="mini"></el-input-number>
        <span style="margin-left:10px">图片剪切:</span>
        <el-switch style="margin-left:5px ;" @change="delBlackBoard" v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </div>
      <div style="display: flex; justify-content: flex-end;">
        <el-button style="margin-left:10px" @click="view1_scan" type="primary" size="mini">兼容拍照</el-button>
        <el-button style="margin-left:10px" @click="view2_scan" type="primary" size="mini">拍照</el-button>
      </div>
      <div class="view-warp">
        <div id="view">
          <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头">
        </div>
        <div id="suoluetu">
          <div v-for="(item, index) in img_base64List" :key="index" class="imgList">
            <el-image style="width: 100px; height: 100px;margin-bottom: 5px;" :src="item" :preview-src-list="img_base64List">
            </el-image>
            <el-button type="danger" @click="delImgList(index)" size="mini">删除</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelGpy">取消</el-button>
        <el-button type="primary" @click="congirmGpyFile">确定</el-button>
      </span>
    </el-dialog>
    
    <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
      <scannerPlugin v-if="scanShow" ref="scannerPlugin" @submit="onSubmit"></scannerPlugin>
    </el-dialog>
    
    <el-dialog title="高拍仪上传" destroy-on-close :visible.sync="photographShow" width="75%" append-to-body top="20px">
      <photograph v-if="photographShow" ref="photograph" @submit="photographSubmit"></photograph>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { upFile } from "@/service/printApi.js";
import DragUpload from '@/byComponents/DragUpload.vue';
import photograph from '@/byComponents/photograph.vue';

export default {
  name: "upDataImg",
  components: {
    DragUpload,
    photograph
  },
  props: {
    // 最大上传数量，0 表示不限制
    limit: {
      type: Number,
      default: 0
    },
    // 良田高拍仪按钮是否显示，不传默认显示
    liangtianShow: {
      type: Boolean,
      default: null
    },
    // 其他高拍仪按钮是否显示，不传时读取全局配置
    isGPY: {
      type: Boolean,
      default: null
    },
    // 扫描仪按钮是否显示，不传时读取全局配置
    printScanShow: {
      type: Boolean,
      default: null
    },
    // 初始回显的文件相对路径数组（如已保存的图片路径）
    initFiles: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      token: { token: sessionStorage.getItem('token') },
      fileList: [],
      requesUrl: '',
      imgUrl: '',
      imageUrl: '',
      dialogImg: false,
      selectedFileUrl: '',
      selectedUid: '',
      scanShow: false,
      photographShow: false,
      dialogGPY: false,
      gpy: false,
      img_base64List: [],
      altimeterData: {
        "filepath": "base64",
        "rotate": "0",
        "cutpage": "0",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1",
        "deskew": "1",
        "deskewval": 50
      },
      switchValue: false
    };
  },
  computed: {
    allUploadUrls() {
      return this.fileList.map(item => item.fileUrl).filter(Boolean)
    },
    // 良田高拍仪按钮显隐：优先使用传入 prop，否则默认显示
    showLiangtian() {
      if (this.liangtianShow !== null) return this.liangtianShow;
      return true;
    },
    // 其他高拍仪按钮显隐：优先使用传入 prop，否则读取全局配置
    showOtherGPY() {
      if (this.isGPY !== null) return this.isGPY;
      try {
        if (window.global_config && typeof window.global_config.isGPY === 'boolean') {
          return window.global_config.isGPY;
        }
      } catch (e) { }
      return false;
    },
    // 扫描仪按钮显隐：优先使用传入 prop，否则读取全局配置
    showScan() {
      if (this.printScanShow !== null) return this.printScanShow;
      try {
        if (window.global_config && typeof window.global_config.printScanShow === 'boolean') {
          return window.global_config.printScanShow;
        }
      } catch (e) { }
      return true;
    }
  },
  methods: {
    handleAvatarSuccess(res, file, fileList) {
      if (res.status === 500) {
        this.$message.error(res.message);
        return;
      }
      this.fileList = fileList;
      this.fileList.forEach(item => {
        if (item.name === res.result[0].fileName) {
          this.$set(item, 'url', this.imgUrl + "/" + res.result[0].fileUrl);
          this.$set(item, 'fileUrl', res.result[0].fileUrl);
        }
      });
      this.$nextTick(() => {
        if (this.fileList.length) this.handleSelect(this.fileList[0]);
      });
    },
    // 数量超限提示
    handleExceed() {
      this.$message.warning(`最多只能上传${this.limit}张图片！`);
    },
    // 剩余可上传数量
    getRemainingCount() {
      return this.limit > 0 ? this.limit - this.fileList.length : Infinity;
    },
    handleSelect(file) {
      this.selectedUid = file.uid;
      this.selectedFileUrl = file.fileUrl;
      console.log(file.fileUrl);
      this.$emit('handleSelectImg', file.fileUrl);
    },
    handlePreview(file) {
      this.imageUrl = file.url;
      this.dialogImg = true;
    },
    handleClose(done) {
      this.dialogImg = false;
      if (done) {
          done();
      }
    },
    deleteFile(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      if (file.uid === this.selectedUid) {
        this.selectedUid = '';
        this.selectedFileUrl = '';
        if (this.fileList.length) {
          this.handleSelect(this.fileList[0]);
        }
      }
    },
    showUploadDialog() {
      if (this.$refs.dragUpload) {
        this.$refs.dragUpload.open();
      }
    },
    onUploadConfirm(files) {
      if (!files || !Array.isArray(files)) return;
      let remaining = this.getRemainingCount();
      let isExceed = false;
      files.forEach(item => {
        var arr = this.fileList.filter((val) => val.name == item.fileName);
        if (arr.length == 0) {
          if (remaining <= 0) {
            isExceed = true;
            return;
          }
          this.fileList.push({
            uid: Date.now() + Math.random(),
            name: item.fileName,
            url: this.imgUrl + "/" + item.fileUrl,
            fileUrl: item.fileUrl,
            fileId: item.fileId
          });
          remaining--;
        }
      });
      if (isExceed) this.handleExceed();
      if (this.fileList.length) {
        this.handleSelect(this.fileList[this.fileList.length - 1]);
      }
    },
    openHighBeatMeter1() {
      this.photographShow = true;
    },
    photographSubmit(imgList) {
      if (!imgList || !Array.isArray(imgList)) {
        this.photographShow = false;
        return;
      }
      var list = JSON.parse(JSON.stringify(imgList));
      let remaining = this.getRemainingCount();
      list.forEach((item) => {
        var arr = this.fileList.filter((val) => val.name == item.fileName);
        if (arr.length == 0) {
          if (remaining <= 0) {
            this.handleExceed();
            return;
          }
          this.fileList.push({
            ...item,
            name: item.fileName,
            url: this.imgUrl + "/" + item.fileUrl
          });
          remaining--;
        }
      });
      this.photographShow = false;
      if (this.fileList.length) {
        this.handleSelect(this.fileList[this.fileList.length - 1]);
      }
    },
    scanUpload() {
      this.scanShow = true;
    },
    onSubmit(scannedImages) {
      if (!scannedImages || !Array.isArray(scannedImages)) {
        this.scanShow = false;
        return;
      }
      var list = JSON.parse(JSON.stringify(scannedImages));
      let remaining = this.getRemainingCount();
      list.forEach((item) => {
        var arr = this.fileList.filter((val) => val.name == item.fileName);
        if (arr.length == 0) {
          if (remaining <= 0) {
            this.handleExceed();
            return;
          }
          this.fileList.push({
            ...item,
            name: item.fileName,
            url: this.imgUrl + "/" + item.fileUrl
          });
          remaining--;
        }
      });
      this.scanShow = false;
      if (this.fileList.length) {
        this.handleSelect(this.fileList[this.fileList.length - 1]);
      }
    },
    delBlackBoard(e) {
      let openFun = e ? 1 : 0;
      this.getStatus(openFun);
    },
    getStatus(e) {
      axios.post("http://127.0.0.1:38088/video=status").then((res) => {
        if (res.data && res.data.code == 0) {
          setTimeout(() => {
            let data = { "camidx": '0', "open": String(e) };
            axios.post("http://127.0.0.1:38088/dvideo=cameradeskew", JSON.stringify(data)).then(() => {});
          }, 500);
        }
      }).catch(() => {});
    },
    delImgList(index) {
      if (index >= 0 && index < this.img_base64List.length) {
        this.img_base64List.splice(index, 1);
      }
    },
    rotate(angle) {
      let data = { "camidx": '0', "rotate": String(angle) };
      axios.post("http://127.0.0.1:38088/video=rotate", JSON.stringify(data)).then(() => {});
    },
    view1_scan() {
      let data = JSON.parse(JSON.stringify(this.altimeterData));
      delete data.deskewval;
      delete data.deskew;
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(data)).then((res) => {
        if (res.data && res.data.photoBase64) {
          this.add_image(res.data.photoBase64);
        }
      }).catch(() => {});
    },
    view2_scan() {
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(this.altimeterData)).then((res) => {
        if (res.data && res.data.photoBase64) {
          this.add_image(res.data.photoBase64);
        }
      }).catch(() => {});
    },
    add_image(img_base64) {
      if (img_base64) {
        this.img_base64List.push("data:image/jpg;base64," + img_base64);
      }
    },
    cancelGpy() {
      this.dialogGPY = false;
      this.gpy = false;
    },
    async congirmGpyFile() {
      var token = sessionStorage.getItem("token");
      if (!token || !this.img_base64List.length) {
        this.dialogGPY = false;
        this.img_base64List = [];
        return;
      }
      this.img_base64List.forEach((key) => {
        try {
          var arr = key.split(',');
          var mime = arr[0].match(/:(.*?);/)[1];
          var bstr = atob(arr[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var timestamp = (new Date()).valueOf();
          const formData = new FormData();
          var fileliu = new File([u8arr], timestamp + '.jpg', { type: mime });
          formData.append('file', fileliu);
          upFile(formData, token).then((res) => {
            if (res && res.status === 200 && res.result && res.result[0]) {
              var exist = this.fileList.filter((val) => val.name == res.result[0].fileName);
              if (exist.length == 0) {
                if (this.getRemainingCount() <= 0) {
                  this.handleExceed();
                  return;
                }
                this.fileList.push({
                  ...res.result[0],
                  name: res.result[0].fileName,
                  url: this.imgUrl + "/" + res.result[0].fileUrl
                });
              }
            }
          }).catch(() => {});
        } catch (e) {
          console.error('图片上传失败:', e);
        }
      });
      this.dialogGPY = false;
      this.img_base64List = [];
      if (this.fileList.length) {
        this.handleSelect(this.fileList[this.fileList.length - 1]);
      }
    },
    openHighBeatMeter() {
      this.img_base64List = [];
      this.gpy = true;
      this.dialogGPY = true;
      setTimeout(() => {
        this.switchValue = true;
        this.getStatus(1);
      }, 100);
    },
    handleClosegpy(done) {
      this.$confirm('确认取消文件上传？')
        .then(_ => {
          this.dialogGPY = false;
          this.img_base64List = [];
          if (done) done();
        })
        .catch(_ => {});
    }
  },
  created() {
    try {
      const config = this.$store.getters.getConfig;
      if (config) {
        this.requesUrl = config.requestUrl || '';
        this.imgUrl = config.imgUrl || '';
      }
    } catch (e) {
      console.error('获取配置失败:', e);
    }
    // 回显已上传的文件
    if (this.initFiles && this.initFiles.length) {
      this.initFiles.forEach((path, index) => {
        this.fileList.push({
          uid: 'init_' + index,
          name: String(path).split('/').pop() || ('图片' + (index + 1)),
          url: (this.imgUrl ? this.imgUrl + '/' : '') + path,
          fileUrl: path
        });
      });
    }
  }
};
</script>

<style scoped>
.upload-demo {
  width: 100%;
}

::v-deep .el-upload-list {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px !important;
  margin-top: 10px !important;
  width: 100% !important;
}
::v-deep .el-upload-list__item {
  width: auto !important;
  height: auto !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.custom-upload-item {
  width: 160px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  border: 2px solid transparent;
  cursor: pointer;
  background: #f5f5f5;
}
.custom-upload-item.active {
  border-color: #13ce66;
}
.custom-img {
  width: 160px;
  height: 160px;
  object-fit: cover;
  display: block;
}

.custom-actions {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  gap: 8px;
  z-index: 10;
}
.custom-actions i {
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: rgba(0,0,0,0.5);
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.select-check {
  position: absolute;
  bottom: 28px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: #13ce66;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 9;
}

.img-name {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
  background: #fff;
}

.view-warp {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
}

#view1 {
  height: 300px;
  border: 1px solid #000;
  margin-right: 5px;
}

#suoluetu {
  width: 460px;
  display: flex;
  flex-wrap: wrap;
  height: 300px;
  overflow-y: auto;
}

#suoluetu .imgList {
  width: 100px;
  height: 140px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  margin: 5px;
}

#myactive {
  margin-top: 10px;
  padding: 10px 5px;
}
</style>
<style scoped>
.el-select {
  width: 150px !important;
}
</style>